import { get, post } from "api";

// PAIRING AN ISSUE WITH A SHOP DRAWING - one piece of work, one set of hours.
//
// Owner, 2026-10-08. The rules all live on the server
// (back/utils/issueDrawingPair): which drawings may be offered, which side
// owns the hours, and the sentence the other side is refused with. These four
// calls are the only way in from the browser, deliberately - a second opinion
// in the client about who owns the hours is how the form and the invoice start
// disagreeing.

// The drawings a picker may offer: NOT delivered and not already paired to
// somebody else. `forIssueId` keeps the issue's OWN current pair in the list,
// so reopening a form shows its existing selection instead of an empty box.
export const pairableDrawings = (projectId, forIssueId) =>
  get(`/projects/${projectId}/shop-drawings/pairable${forIssueId ? `?forIssueId=${forIssueId}` : ""}`);

// The mirror of pairableDrawings, for the shop-drawing form.
export const pairableIssues = (projectId, forDrawingId) =>
  get(`/issue/project/${projectId}/pairable${forDrawingId ? `?forDrawingId=${forDrawingId}` : ""}`);

export const pairIssueToDrawing = (issueId, shopDrawingId) =>
  post(`/issue/${issueId}/pair-shop-drawing`, { shopDrawingId });

export const unpairIssue = (issueId) =>
  post(`/issue/${issueId}/unpair-shop-drawing`, {});

export const pairDrawingToIssue = (projectId, shopDrawingId, issueId) =>
  post(`/projects/${projectId}/shop-drawings/${shopDrawingId}/pair-issue`, { issueId });
// What an issue's page shows: its paired drawing, the pair's one hours figure
// and the side it was entered on, and whether this person may link / unlink.
export const getIssuePair = (issueId) => get(`/issue/${issueId}/pair`);
export const unpairDrawing = (projectId, shopDrawingId) =>
  post(`/projects/${projectId}/shop-drawings/${shopDrawingId}/unpair-issue`, {});
